<template>
    <div id="page_02" class="page">
        <div class="content">
            <div class="content_area">
                <div class="item item_left">
                    <p>
                        <span>
                            프리미엄 아이템
                        </span><br/>
                        <span>
                            100여개의 패션 브랜드
                        </span><br/>
                        <span>
                            스트릿 패션 13년 유통 노하우
                        </span>
                    </P>
                </div>
                <div class="item item_right">
                    <img src="@/assets/img/img_page_02_01.png" />
                </div>
                <div class="clear"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Page02'
}
</script>

<style scoped>
    .content{background-image:url("../assets/img/bg_page_02.jpg");padding-top:5.768rem;padding-bottom:5.77rem;}
    .item>p{font-weight:bold;line-height:1.92rem;}
    .item>p>span{border-bottom:0.1rem solid #000;}
    .item>img{width:10.096rem;height:auto;}
    .item_right{margin-left:2.472rem;}

    @media (max-width:720px) {
        .item_right{margin:0;margin-top:2rem;}
    }
</style>